// extracted by mini-css-extract-plugin
export var closeButton = "_fa-2";
export var closeButtonIcon = "_fa-3";
export var lightboxContent = "_fa-1";
export var lightboxOverlay = "_fa-0";